import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, LoadingController } from 'ionic-angular';
import { UserMarketing as User } from '@providers/index';
import { LoginPage } from '@pages/marketing/login/page';

@Component({
  selector: 'page-profile',
  templateUrl: 'page.html'
})
export class ProfilePage {

  emp:any;
  loading:any;
  
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public userApi: User
  ) {
    this.emp = this.userApi.data;
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }
    
}



// WEBPACK FOOTER //
// ./src/pages/marketing/profile/page.ts